import React from 'react';
import { ITeamData } from '@/models/team';
import { BsFacebook, BsInstagram, BsTiktok, BsTwitter, BsYoutube } from 'react-icons/bs';
import Link from 'next/link';

export type SocialMediaKey = 'facebook' | 'twitter' | 'instagram' | 'tiktok' | 'youtube';

export const defaultSocialIconMap: Record<SocialMediaKey, React.ReactNode> = {
	facebook: (
		<BsFacebook className="fill-white w-6 h-6 hover:cursor-pointer hover:opacity-60 transition-all duration-200" />
	),
	twitter: (
		<BsTwitter className="fill-white w-6 h-6 hover:cursor-pointer hover:opacity-60 transition-all duration-200" />
	),
	instagram: (
		<BsInstagram className="fill-white w-6 h-6 hover:cursor-pointer hover:opacity-60 transition-all duration-200" />
	),
	tiktok: (
		<BsTiktok className="fill-white w-6 h-6 hover:cursor-pointer hover:opacity-60 transition-all duration-200" />
	),
	youtube: (
		<BsYoutube className="fill-white w-6 h-6 hover:cursor-pointer hover:opacity-60 transition-all duration-200" />
	),
};

interface SocialLinksProps {
	socialLinks: ITeamData['contestantSocialLinks'];
	iconMap?: Record<SocialMediaKey, React.ReactNode>;
	className?: string;
}

function SocialLinks({ socialLinks, iconMap = defaultSocialIconMap, className }: SocialLinksProps) {
	if (!socialLinks) return null;

	return (
		<div className={`flex gap-4 mb-4 ${className || ''}`}>
			{Object.entries(socialLinks).map(([platform, url]) => {
				if (!url) return null;

				const platformKey = platform as SocialMediaKey;
				return (
					<Link
						key={platform}
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						aria-label={`${platform}`}
					>
						{iconMap[platformKey] || <span>{platformKey}</span>}
					</Link>
				);
			})}
		</div>
	);
}

export default SocialLinks;
